// TODO: Disabled linter, specifically for using a div as a button. This should be a temporary solution and solved properly in the future.
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';
import i18n from 'i18n-react';

import ContentHeader from 'components/ContentHeader';
import TrainingExtraCard from 'components/TrainingGrid/TrainingExtraCard';

import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

import { useChapters } from 'hooks/useChapters';
import { useSettings } from 'hooks/useSettings';
import { useUserInfo } from 'hooks/useUserInfo';

import { storageKeys } from 'settings';

const trackShare = (name) => {
  // TODO: Commented unused code during the Translations update. Remove if not needed.
  // const trackShare = (chapterNumber, name) => {
  // const value = `chapter-${chapterNumber}`;
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = 'Guest';
      ({ email } = userObj);
      APIHandler.trackEvent(appId, email, 'retention', 'chapter', window.location.href, name).then(() => {});
    });
  });
};

const trackShareSub = (name, uri) => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = 'Guest';
      ({ email } = userObj);
      APIHandler.trackEvent(appId, email, 'collateral', 'subapp', uri, name).then(() => {});
    });
  });
};

// Renders a specfic section (category) of grouped training links (chapters), including facts, progress, etc.
const SubappsViewNew = ({ match }) => {
  const { id } = match.params;

  const { subapps } = useChapters();
  const { appId, lang } = useSettings();
  const { user } = useUserInfo();
  const { email } = user;
  // filters the categories for extra learning
  const extraLearningCategories = useMemo(
    () => subapps.filter((extraCategory) => extraCategory.id === Number(id)),
    [subapps, id],
  );

  const { langFile } = lang;
  const { color, modules = [], chapterIDs } = extraLearningCategories[0] || {};

  // Function to generate the external link for the module
  const extLinkUrl = useCallback(
    (moduleItem) => {
      const {
        session_chapter_id: chapterID = 0,
        sub_app: { id: subAppId = '' } = {},
        progress: progressRate,
      } = moduleItem || {};

      const { count } = moduleItem;
      const { total_count: totalCount } = count;

      const chapterId = chapterID;
      const { highest_page: highestPage = 0 } = progressRate || { highest_page: 0 };
      const progress = totalCount <= highestPage ? '0' : highestPage;

      const redirPath = window.location.href;
      const pathName = totalCount <= highestPage ? 'ret' : 'training';
      const live = `https://usadpbadge.com/${pathName}`;
      const currentPageUrlAndPath = redirPath;

      // eslint-disable-next-line max-len
      return `${live}/${subAppId}/${email}/${chapterId}/${progress}/true/true/?lang=${langFile}&redirurl=${currentPageUrlAndPath}`;
    },
    [email, langFile],
  );

  const filteredModules = useMemo(
    () =>
      modules.filter((moduleItem) => {
        const { id: moduleID } = moduleItem;
        return chapterIDs.includes(moduleID);
      }),
    [modules, chapterIDs],
  );

  const renderedModules = useMemo(() => {
    const classes = clsx(
      'trainingCard__Animated',
      'trainingExtraView__chapter',
      'trainingExtraView__chapter--uncompleted',
    );

    return filteredModules
      .sort((a, b) => a.title?.localeCompare(b.title))
      .map((moduleItem) => {
        const { id: moduleID, title } = moduleItem;
        if (extLinkUrl(moduleItem).includes('https://usadpbadge.com/ret')) {
          return (
            <div
              className={classes}
              key={`ch${moduleID}`}
              onClick={() => trackShareSub(moduleID, title, extLinkUrl(moduleItem))}
            >
              <TrainingExtraCard appId={appId} module={moduleItem} redirPath={extLinkUrl(moduleItem)} />
            </div>
          );
        }
        return (
          <div className={classes} key={`ch${moduleID}`} onClick={() => trackShare(moduleID, title)}>
            <TrainingExtraCard appId={appId} module={moduleItem} redirPath={extLinkUrl(moduleItem)} />
          </div>
        );
      });
  }, [appId, filteredModules, extLinkUrl]);

  const locale = `${langFile.toLowerCase()}-${langFile
    .replace('pt', 'BR')
    .replace('es', '41')
    .replace('ko', 'kr')
    .toUpperCase()}`;
  let subHeadTitle = extraLearningCategories[0]?.title;
  if (langFile !== 'en' && extraLearningCategories[0]?.translations?.length > 0) {
    subHeadTitle = extraLearningCategories[0]?.translations.find((t) => t.locale === locale)?.title || subHeadTitle;
  }

  return (
    <div className="contentContainer trainingExtraView">
      <ContentHeader header={subHeadTitle} subtitle={i18n.translate('newTrainingFlow.partnerModules')} line />

      <div className="trainingGrid trainingExtraView__grid">{renderedModules} </div>
      {color && (
        <style>
          {`
        :root {
          --section-color: ${color};
        }
      `}
        </style>
      )}
    </div>
  );
};

SubappsViewNew.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape().isRequired,
  }).isRequired,
};

export default SubappsViewNew;
